import React from 'react';

const AdminOfferingDetailsFields = ({ form, setForm, disabled, idPrefix = "offering", variant = "default" }) => {
  const luxury = variant === "admin-luxury";
  const rowClass = luxury ? "admin-offering-panel__form-row" : "form-row";
  const groupClass = luxury ? "admin-offering-panel__form-group" : "form-group";
  const labelClass = luxury ? "admin-offering-panel__label" : undefined;
  const inputClass = luxury ? "admin-offering-panel__input" : undefined;
  const optionalClass = luxury ? "admin-offering-panel__label-optional" : undefined;

  return (
    <div className={luxury ? "admin-offering-panel__form-grid" : undefined}>
      <div className={rowClass}>
        <div className={groupClass}>
          <label className={labelClass} htmlFor={`${idPrefix}-funding-deadline`}>Funding deadline</label>
          <input
            id={`${idPrefix}-funding-deadline`}
            className={inputClass}
            placeholder="e.g. 30 Jun 2026 or 2026-06-30"
            value={form.fundingDeadline}
            onChange={(e) => setForm((prev) => ({ ...prev, fundingDeadline: e.target.value }))}
            disabled={disabled}
          />
        </div>
        <div className={groupClass}>
          <label className={labelClass} htmlFor={`${idPrefix}-projected-timeline`}>Projected timeline</label>
          <input
            id={`${idPrefix}-projected-timeline`}
            className={inputClass}
            placeholder="e.g. 18 months"
            value={form.projectedTimeline}
            onChange={(e) => setForm((prev) => ({ ...prev, projectedTimeline: e.target.value }))}
            disabled={disabled}
          />
        </div>
      </div>
      <div className={rowClass}>
        <div className={groupClass}>
          <label className={labelClass} htmlFor={`${idPrefix}-property-manager-name`}>Property manager / lister</label>
          <input
            id={`${idPrefix}-property-manager-name`}
            className={inputClass}
            placeholder="Company or contact name"
            value={form.propertyManagerName}
            onChange={(e) =>
              setForm((prev) => ({ ...prev, propertyManagerName: e.target.value }))
            }
            disabled={disabled}
          />
        </div>
        <div className={groupClass}>
          <label className={labelClass} htmlFor={`${idPrefix}-property-manager-license`}>
            License / reference{" "}
            <span className={optionalClass || undefined} style={luxury ? undefined : { fontWeight: 400, opacity: 0.75 }}>
              (optional)
            </span>
          </label>
          <input
            id={`${idPrefix}-property-manager-license`}
            className={inputClass}
            placeholder="e.g. license ID or reference number"
            value={form.propertyManagerLicenseReference}
            onChange={(e) =>
              setForm((prev) => ({
                ...prev,
                propertyManagerLicenseReference: e.target.value
              }))
            }
            disabled={disabled}
          />
        </div>
      </div>
      <div className={rowClass}>
        <div className={groupClass}>
          <label className={labelClass} htmlFor={`${idPrefix}-developer-name`}>Developer</label>
          <input
            id={`${idPrefix}-developer-name`}
            className={inputClass}
            value={form.developerName}
            onChange={(e) => setForm((prev) => ({ ...prev, developerName: e.target.value }))}
            disabled={disabled}
          />
        </div>
        <div className={groupClass}>
          <label className={labelClass} htmlFor={`${idPrefix}-developer-track`}>Developer track record</label>
          <input
            id={`${idPrefix}-developer-track`}
            className={inputClass}
            value={form.developerTrackRecord}
            onChange={(e) => setForm((prev) => ({ ...prev, developerTrackRecord: e.target.value }))}
            disabled={disabled}
          />
        </div>
      </div>
      <div className={rowClass}>
        <div className={groupClass}>
          <label className={labelClass} htmlFor={`${idPrefix}-risk`}>Risk rating</label>
          <select
            id={`${idPrefix}-risk`}
            className={inputClass}
            value={form.riskRating}
            onChange={(e) => setForm((prev) => ({ ...prev, riskRating: e.target.value }))}
            disabled={disabled}
          >
            <option value="">— Select —</option>
            <option value="Low">Low</option>
            <option value="Medium">Medium</option>
            <option value="High">High</option>
          </select>
        </div>
        <div className={groupClass}>
          <label className={labelClass} htmlFor={`${idPrefix}-offering-type`}>Offering type</label>
          <select
            id={`${idPrefix}-offering-type`}
            className={inputClass}
            value={form.secOfferingType}
            onChange={(e) => setForm((prev) => ({ ...prev, secOfferingType: e.target.value }))}
            disabled={disabled}
          >
            <option value="">— Select —</option>
            <option value="Reg_CF">Reg CF</option>
            <option value="Reg_A">Reg A</option>
            <option value="Reg_D">Reg D</option>
            <option value="Private">Private placement</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default AdminOfferingDetailsFields;
